import { Component } from 'react';
import { connect } from 'react-redux';
import {
  Page, Card, Layout, SkeletonBodyText, BlockStack,Toast, Select, Text,
  PageActions,
  Box,
} from "@shopify/polaris";

import NavTabs from "../components/NavTabs";
import { reqGetInfoSetting, reqPutSettingSave } from '../../../../api';

import SettingPrompt from '../../../../components/SettingPrompt';
import intl from '../../../../i18n/intl';
import { changeLanguageData } from '../../../../slice';
import './index.css';

class ProfileClass extends Component {

  state = {
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误

    loadingPage: true,
    saveDataLoading: false,
    disabledSaveData: true,

    AuthButtonDisable: false,
    disconnectActive: false,
    //语言设置
    languageOptions: [
      { label: "English", value: "en" },
      { label: "Français", value: "fr" },
      { label: "Deutsch", value: "de" },
      { label: "Español", value: "es" },
      { label: "Dutch", value: "nl" },
      { label: "Italiano", value: "it" },
      { label: "Portugal", value: "pt-pt" },
      { label: "Portugal(Brasil)", value: "pt-br" },
    ],
    selected: 'en',
    isLanguageChange: false,
  };

  //进入页面调用接口
  componentDidMount() {
    this.getUserSettingsData();
  }
  componentWillUnmount = () => {
    this.setState = (state,callback)=>{
      return;
    };
  }
  //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: showToastText !== "",
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  getUserSettingsData = async () => {
    const params = { type: 'language' };
    const response = await reqGetInfoSetting(params);
    if (response.code === '200') {
      var result = response.data;
      this.setState({
        selected: result.language, // 语言设置
        loadingPage: false,
        defaultLanguage: result.language,
      });

    } else {
      this.toggleToast(response.msg);
    }
  }

  // save setting
  saveData = async () => {
    this.setState({ saveDataLoading: true });
    const params = {
      type:'language',
      language: this.state.selected
    };

    const responseData = await reqPutSettingSave(params);

    this.setState({ saveDataLoading: false });
    this.props.dispatch(changeLanguageData({ language: this.state.selected, isLanguageChange: true }))

    // 选择的语言
    window.language = this.state.selected;

    if (responseData.code === "200") {
      this.toggleToast('Saved successfully');
      if (this.state.isLanguageChange) { // 修改语言，则刷新框架组件
        this.props.callBackFun();
      }
      this.setState({
        disabledSaveData: true,
        defaultLanguage: this.state.selected,
      })
      setTimeout(() => {
          this.props.changeSettingBtnState(false)
      }, 500);
    } else {
      this.props.changeSettingBtnState(false)
      this.toggleToast(responseData.msg);
    }
  };
  cancelData = () => {
    this.setState({
      selected: this.state.defaultLanguage,
      isLanguageChange: false,
      disabledSaveData: true,
    },()=>{
      this.props.changeSettingBtnState(false)
    });
  }
  // 语言设置
  handleSelectChange = (value) => {
    this.setState({
      selected: value,
      isLanguageChange: true,
      disabledSaveData:value === this.state.defaultLanguage ? true : false
    },()=>{
      if (!(value === this.state.defaultLanguage) ) {
        this.props.changeSettingBtnState(true)
        window.saveSettings = {saveData:this.saveData};
        window.cancelSetting = {cancelData:this.cancelData};
      }else {
        this.props.changeSettingBtnState(false)
      }
    });
  }


  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} duration={2000} onDismiss={() => this.toggleToast('')} error={this.state.showToastIserror} /> : null;
    const {
     saveDataLoading, disabledSaveData,
      languageOptions, selected
    } = this.state;

    const initSkeletonPage = <div>
       <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
      </div>

    const pageContent = this.state.loadingPage ? initSkeletonPage : <div>
      <BlockStack gap={400}>
        <Box className='h1_m'>
          <Text variant="headingLg" as="h5">
         Language
        </Text>
        </Box>
        <Card>
          <Text variant="headingMd" as="h2">
          {intl.get("Language")}
          </Text>
          <p style={{color:'rgba(97, 97, 97, 1)'}}>
          Select the language you'd like to use. It will only change the interface language, not product 
          descriptions.
          </p>
          <div style={{paddingTop:"10px",width:'200px'}}>
            <Select
              label={``}
              options={languageOptions}
              onChange={this.handleSelectChange}
              value={selected}
            />
            </div>
        </Card>
        </BlockStack>
      </div>
    const shopify = window.shopify;
    return (
      <div id="settings_class">
        {/* 未保存拦截弹窗 */}
        {!shopify && <SettingPrompt disabledSaveData={disabledSaveData} url='/admin/settings/language' saveData={this.saveData} />}
        <Page
          title={shopify ? '' : intl.get("Settings")}
          separator
        >
        <Layout>
        <Layout.Section variant="oneThird">
            <NavTabs selected="Language" saveData={this.saveData} loading={saveDataLoading} disabled={disabledSaveData}/>
        </Layout.Section>
        <Layout.Section>
        {pageContent}
        </Layout.Section>
        </Layout>
          {toastMarkup}
          {!shopify && <PageActions 
          primaryAction={
            {
              content: intl.get("Save"),
              onAction: this.saveData,
              loading: saveDataLoading,
              disabled: disabledSaveData
            }
          }
          >
            </PageActions>}
        </Page>

      </div>
    );

  }
}

export default connect()(ProfileClass);